var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Grid, Typography } from "../index";

var Headline = function Headline(_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      children = _a.children,
      props = __rest(_a, ["title", "subtitle", "children"]);

  return React.createElement(Grid.Box, __assign({
    justifyContent: "center",
    display: "flex",
    flexDirection: "column",
    maxWidth: "746px",
    m: "0 auto"
  }, props), React.createElement(Typography, {
    variant: "h2",
    textAlign: "center",
    mb: 4
  }, title), React.createElement(Typography, {
    textAlign: "center"
  }, subtitle), children);
};

export default Headline;